export default __webpack_public_path__ + "static/media/teemo_sunset.9ff46f0d.png";